import React from 'react';
import { enumValue, formatDateTime, formatUserName } from '~/util';
import { NoteIcon, NoteBody, NoteTitle } from '~/components/Patient/Notes/Note';

export interface NoteProps {
    note: NoteType;
    patient?: PatientType;
    gap?: GapType | RiskGapType;
    entityId: number;
    enableOpenModal?: boolean;
    previousNote?: NoteType;
}
export function Note({
    note,
    patient,
    gap,
    entityId,
    enableOpenModal = false,
    previousNote,
}: NoteProps) {
    function retrievedGap() {
        if (gap) {
            return gap;
        }
        switch (note.type) {
            case enumValue(['note', 'type', 'Risk Gap Note']):
                return patient?.risk_gaps.find((x) => x.id === note?.risk_gap?.id);
            case enumValue(['note', 'type', 'FOC Gap Note']):
                return patient?.foc_gaps.find((x) => x.id === note?.foc_gap?.id);
            case enumValue(['note', 'type', 'Quality Gap Note']):
                return patient?.quality_gaps.find((x) => x.id === note?.quality_gap?.id);
            default:
                return null;
        }
    }

    return (
        <div className="card border-info mb-2 note-card">
            <div className="card-header card-header-ignore-margin">
                <div className="row">
                    <div className="col-6">
                        <div className="pull-left">
                            <NoteIcon action={note?.action} />
                            {note.created_by_user && (
                                <span className="fw-bold">
                                    {formatUserName(note.created_by_user)}{' '}
                                </span>
                            )}
                            <NoteTitle
                                note={note}
                                entityId={entityId}
                                enableOpenModal={enableOpenModal}
                                gap={retrievedGap()}
                            />
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="pull-right">
                            <span className="badge badge-outline-secondary audit-report-year">
                                {note.report_year}
                            </span>
                            <span>{formatDateTime(note.updated_at)}</span>
                        </div>
                    </div>
                </div>
            </div>
            <NoteBody note={note} gap={retrievedGap()} previousNote={previousNote} />
        </div>
    );
}
